import { Stack } from '@mui/material'
import React from 'react'
import { Coordinates, type VendorHighlightCategoriesFilterInput } from '@/generated/graphql'
import { VendorSearchState } from '../../states/useVendorSearchState'
import SupplierHighlightList, {
  highlightCategoryWithVendorsFragment,
} from '../supplier-highlight-list'
import { FragmentType, useFragment } from '@/generated/gql'

type Props = {
  location: Coordinates
  search: VendorSearchState['search']
  highlightFilters: VendorHighlightCategoriesFilterInput
  highlightCategoryData: FragmentType<typeof highlightCategoryWithVendorsFragment>[]
}

const SupplierHighlightsCategory: React.FC<Props> = ({
  search,
  highlightCategoryData,
  location,
  highlightFilters,
}) => {
  const handleViewMoreClick = (tagName: string) => {
    search({ highlightsTags: [tagName] })
  }

  const categories = useFragment(highlightCategoryWithVendorsFragment, highlightCategoryData)

  return (
    <Stack spacing={2} marginBottom={1} direction="column">
      {categories?.map((highlight, index) => {
        const highlightRef = highlightCategoryData[index]
        if (!highlight || !highlightRef) return null
        return (
          <SupplierHighlightList
            location={location}
            highlightFilters={highlightFilters}
            vendorData={highlight.vendors}
            onViewMoreClick={(tagName) => handleViewMoreClick(tagName)}
            highlightCategoryData={highlightRef}
            key={highlight.id}
          />
        )
      })}
    </Stack>
  )
}

export default SupplierHighlightsCategory
export { SupplierHighlightsCategory }
